import { GetServerSideProps } from 'next'

import FaqPage from '@features/faq/pages/FaqPage'
import { BASE_URL } from '@configs/config'
import { maintenanceHandler } from '@lib/maintenanceHandler'

export default function Faq({ url }: { url: string }) {
  return <FaqPage url={url} />
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}
